webpackJsonp([5],{

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(116).extend({});


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(185).extend({
  template: __webpack_require__(644),
  props: {
    payload: {
      "default": null
    },
    ignoreEsc: {
      "default": false
    }
  },
  computed: {
    popupKey: function() {
      return this.payload.key;
    },
    popupName: function() {
      return this.payload.name;
    },
    popupId: function() {
      return this.payload.id;
    }
  },
  methods: {
    hide: function() {
      return this.$store.dispatch('popups/hide', this.payload);
    },
    emitPopupEvent: function(name, payload) {
      if (payload == null) {
        payload = {};
      }
      return this.$popups.$emit('custom', {
        key: this.popupKey,
        name: this.popupName,
        id: this.popupId,
        event: name,
        payload: payload
      });
    }
  },
  created: function() {
    if (this.ignoreEsc === true) {
      return this.$store.dispatch('popups/ignoreEsc', this.payload);
    }
  }
});


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

var _;

_ = __webpack_require__(0);

module.exports = __webpack_require__(185).extend({
  template: __webpack_require__(643),
  mixins: [__webpack_require__(199)],
  computed: {
    visible: function() {
      return _.any(this.popupsOrder);
    },
    popupsOrder: function() {
      return this.$store.state.popups.popupsOrder;
    },
    popups: function() {
      return this.$store.state.popups.popups || {};
    }
  },
  methods: {
    componentNameForKey: function(key) {
      return "popup-" + (this.dataForKey(key).name);
    },
    dataForKey: function(key) {
      return this.popups[key] || {};
    },
    onKeyupEsc: function() {
      return this.$store.dispatch('popups/windowKeyupEsc');
    }
  },
  watch: {
    visible: function(value) {
      if (value === true) {
        return document.getElementsByTagName('body')[0].setAttribute('class', 'comp-popups-container-visible');
      } else {
        return document.getElementsByTagName('body')[0].setAttribute('class', '');
      }
    }
  }
});


/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-popups-container\" :class=\"[visible ? 'comp-popups-container-visible' : '']\">\n  <component v-for=\"key in popupsOrder\" :is=\"componentNameForKey(key)\" :payload=\"dataForKey(key)\" :key=\"key\"></component>\n</div>";

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-popup\">\n  <popup-content :popup-key=\"popupKey\">Hello World</popup-content>\n</div>";

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(185).extend({
  template: __webpack_require__(646),
  props: {
    popupKey: {
      "default": null
    },
    title: {
      "default": null
    },
    closeText: {
      "default": null
    },
    mode: {
      "default": 'overlay'
    },
    hideBackdrop: {
      "default": false
    },
    hideCloseButton: {
      "default": false
    },
    showCloseButton: {
      "default": false
    }
  },
  computed: {
    hasBackdrop: function() {
      return this.hideBackdrop === false || this.hideBackdrop === 'false';
    },
    hasHeader: function() {
      return this.mode === 'window' || this.mode === 'modal';
    },
    hasFooter: function() {
      return this.mode === 'alert' || this.mode === 'confirm' || this.mode === 'modal';
    },
    hasCloseButton: function() {
      if (this.showCloseButton === true || this.showCloseButton === 'true') {
        return true;
      }
      if (this.hideCloseButton === true || this.hideCloseButton === 'true') {
        return false;
      }
      return this.mode === 'window';
    },
    styleInside: function() {
      var style;
      style = {};
      return style;
    },
    styleMain: function() {
      var style;
      style = {};
      return style;
    }
  },
  methods: {
    onClickBackdrop: function() {
      return this.$emit('click-backdrop');
    },
    onClickBtnClose: function() {
      return this.$emit('click-close');
    }
  }
});


/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports = "\n<div class=\"comp-popup-content\">\n  <div class=\"comp-popup-content-backdrop\" v-if=\"hasBackdrop\" v-on:click.prevent=\"onClickBackdrop\"></div>\n  <div class=\"comp-popup-content-inside\" :style=\"styleInside\">\n    <div class=\"comp-popup-content-header\" v-if=\"hasHeader\">\n      <div class=\"comp-popup-content-header-title\" v-html=\"title\"></div>\n      <div class=\"comp-popup-content-header-close-text\" v-html=\"closeText\"></div><a class=\"btn-close\" href=\"#\" v-if=\"hasCloseButton\" v-on:click.prevent=\"onClickBtnClose\"><i class=\"mdi mdi-close\"></i></a>\n    </div>\n    <div class=\"comp-popup-content-main\" :style=\"styleMain\">\n      <slot></slot>\n    </div>\n    <div class=\"comp-popup-content-footer\" v-if=\"hasFooter\">\n      <slot name=\"footer\"></slot>\n    </div>\n  </div>\n</div>";

/***/ })

});


// WEBPACK FOOTER //
// js/frontend-shared-2a2b4f47a8c260c8fdff.js